<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Next Step</span>
            <el-button class="white-btn" size="small" @click="submitForm" :loading="loading" :disabled="loading || !hasChanges">
                Save
            </el-button>
        </template>

        <el-form
            ref="ruleFormRef"
            :model="form"
            status-icon
            :rules="rules"
            label-position="top"
            class="demo-ruleForm"
        >
            <el-form-item label="Next Step" prop="next_step">
                <el-select v-model="form.next_step" placeholder="Select" style="width: 100%" clearable @change="onNextStepChange">
                    <el-option
                        v-for="option in nextStepOptions"
                        :key="option"
                        :label="option"
                        :value="option"
                    />
                </el-select>
            </el-form-item>

            <el-form-item
                v-if="form.next_step === 'Other'"
                label="Other Next Step"
                prop="next_step_other"
            >
                <el-input
                    v-model="form.next_step_other"
                    type="textarea"
                    :rows="3"
                    placeholder="Enter next step details..."
                />
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
import {
    ElCard, ElButton, ElForm, ElFormItem, ElSelect, ElOption, ElInput
} from 'element-plus'

const NEXT_STEP_OPTIONS = [
    'Contact in less than a week',
    'Contact after 1 week',
    'Contact next month',
    'Not Interested',
    'Other',
];

export default {
    name: "EnquiryNextStep",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: { ElCard, ElButton, ElForm, ElFormItem, ElSelect, ElOption, ElInput },
    data() {
        return {
            loading: false,
            nextStepOptions: NEXT_STEP_OPTIONS,
            form: {
                next_step: '',
                next_step_other: '',
            },
            rules: {
                next_step_other: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.form.next_step === 'Other' && (!value || !String(value).trim())) {
                                callback(new Error('Enter next step details'));
                            } else {
                                callback();
                            }
                        },
                        trigger: ['blur', 'change'],
                    }
                ],
            },
        }
    },
    computed: {
        hasChanges() {
            return (
                (this.form.next_step || '') !== (this.enquiry?.next_step || '') ||
                (this.form.next_step_other || '') !== (this.enquiry?.next_step_other || '')
            );
        }
    },
    watch: {
        enquiry: {
            immediate: true,
            handler(value) {
                this.form.next_step = value?.next_step || '';
                this.form.next_step_other = value?.next_step_other || '';
            }
        }
    },
    methods: {
        onNextStepChange(value) {
            if (value !== 'Other') {
                this.form.next_step_other = '';
            }
        },
        submitForm() {
            const formEl = this.$refs.ruleFormRef;
            if (!formEl) {
                return;
            }
            formEl.validate((valid) => {
                if (valid) {
                    this.save();
                }
            });
        },
        save() {
            if (!this.hasChanges || this.loading) {
                return;
            }

            let currentObj = this;
            currentObj.loading = true;
            axios.post('/enquiry/saverelationshipnextstep?id=' + this.enquiry.id, {
                section: 'next_step',
                next_step: this.form.next_step || null,
                next_step_other: this.form.next_step === 'Other' ? (this.form.next_step_other || null) : null,
            }).then(function (response) {
                toastr.success(response.data.message || 'Updated successfully.');
                currentObj.$emit('saved');
                currentObj.loading = false;
            }).catch(function (error) {
                currentObj.loading = false;
                const message = error?.response?.data?.message || 'Something Wrong try again.';
                toastr.error(message);
            });
        }
    }
}
</script>

<style scoped>
</style>
